import { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "./translations";

const I18nCtx = createContext(null);

export const LANGUAGES = [
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "en", label: "EN", name: "English" },
  { code: "ta", label: "தமிழ்", name: "தமிழ்" },
];

const VALID_CODES = ["de", "en", "ta"];

function detectInitialLang() {
  try {
    const stored = localStorage.getItem("nv_lang");
    if (stored && VALID_CODES.includes(stored)) return stored;
  } catch {
    // ignore
  }
  // Default to DE for all first-time visitors (Swiss app)
  return "de";
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(detectInitialLang);

  useEffect(() => {
    try { localStorage.setItem("nv_lang", lang); } catch { /* ignore */ }
    document.documentElement.lang = lang;
    document.title = "NIVARA Foundation";
  }, [lang]);

  const t = (key, vars = {}) => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.de;
    let str = dict[key];
    if (str === undefined) str = TRANSLATIONS.de[key];
    if (str === undefined) str = key;
    Object.entries(vars).forEach(([k, v]) => {
      str = str.replace(`{${k}}`, v);
    });
    return str;
  };

  return (
    <I18nCtx.Provider value={{ lang, setLang, t }}>
      {children}
    </I18nCtx.Provider>
  );
}

export function useI18n() {
  return useContext(I18nCtx);
}

export function useT() {
  return useI18n().t;
}
